<template>
	<div
		ref="cartContainer"
		class="bg-background w-full flex flex-col overflow-y-auto px-2 select-none"
		style="height: 100dvh"
	>
		<div class="">
			<div class="flex justify-between w-full items-top py-2">
				<div
					class="text-vc-header-xl"
					style="font-family: Gascogne Serial Medium; line-height: 1"
				>
					Carrito
				</div>
				<svg
					xmlns="http://www.w3.org/2000/svg"
					fill="none"
					viewBox="0 0 24 24"
					stroke-width="1.5"
					stroke="currentColor"
					class="cursor-pointer w-6 h-6"
					@click="props.toggle()"
				>
					<path
						stroke-linecap="round"
						stroke-linejoin="round"
						d="M6 18 18 6M6 6l12 12"
					/>
				</svg>
			</div>
		</div>

		<div class="border rounded-lg p-2 bg-background mb-4">
			<div class="flex flex-row justify-between">
				<div>Subtotal</div>
				<div v-if="cartItems.length > 0">${{ formatPrice(subTotal) }}</div>
			</div>

			<div class="flex flex-row justify-between">
				<div>Envío</div>
				<div>Se calculca en el checkout</div>
			</div>

			<div class="flex flex-row justify-between font-bold">
				<div>Total</div>
				<div v-if="cartItems.length > 0">${{ formatPrice(subTotal) }}</div>
			</div>

			<div
				class="cursor-pointer h-11 w-full text-center bg-accent-red mt-4 rounded-md justify-center flex flex-col content-center"
				@click="checkout()"
			>
				<div class="text-white text-vc-small font-medium">CHECKOUT</div>
			</div>
		</div>

		<!-- Agregar y papel de regalo, bolsa chida, ... -->

		<div class="overflow-y-scroll grow">
			<!-- Merch section -->
			<div class="border rounded-lg p-2 mb-4">
				<div class="flex flex-row justify-between items-center">
					<label>Merch</label>
					<div
						class="cursor-pointer"
						@click="showMerch = !showMerch"
					>
						<svg
							xmlns="http://www.w3.org/2000/svg"
							fill="none"
							viewBox="0 0 24 24"
							stroke-width="1.5"
							stroke="currentColor"
							class="w-6 h-6 transition-transform duration-200"
							:class="{ 'rotate-180': !showMerch }"
						>
							<path
								stroke-linecap="round"
								stroke-linejoin="round"
								d="M19.5 8.25l-7.5 7.5-7.5-7.5"
							/>
						</svg>
					</div>
				</div>
				<div
					v-if="showMerch && hasAvailableMerch"
					class="space-y-2 mt-2"
				>
					<div
						v-for="accessory in accessories"
						:key="accessory.id"
						class=""
					>
						<div
							v-if="!getCartItem(accessory)"
							class="flex flex-row justify-between items-center"
						>
							<div class="flex flex-row space-x-2 items-center">
								<div class="h-12 w-12 flex-none rounded-lg bg-white overflow-hidden">
									<ProductPhotoComponent :photo="accessory.image" />
								</div>
								<div>
									<div>{{ accessory.title.split(' - ')[0] }}</div>
									<div class="text-sm text-gray-600">${{ formatPrice(accessory.price) }}</div>
								</div>
							</div>
							<div
								class="px-4 text-white font-normal cursor-pointer h-8 text-center bg-accent-red rounded-full justify-center flex flex-col content-center font-medium"
								@click="modifyCartItem(1, accessory)"
							>
								Agregar
							</div>
						</div>
					</div>
				</div>
			</div>

			<!-- Notes section -->
			<div class="border rounded-lg p-2 mb-4">
				<div>
					<div class="flex flex-row justify-between items-center">
						<label>Agregar una nota a tu pedido</label>
						<div
							class="cursor-pointer"
							@click="showNotes = !showNotes"
						>
							<svg
								xmlns="http://www.w3.org/2000/svg"
								fill="none"
								viewBox="0 0 24 24"
								stroke-width="1.5"
								stroke="currentColor"
								class="w-6 h-6 transition-transform duration-200"
								:class="{ 'rotate-180': !showNotes }"
							>
								<path
									stroke-linecap="round"
									stroke-linejoin="round"
									d="M19.5 8.25l-7.5 7.5-7.5-7.5"
								/>
							</svg>
						</div>
					</div>
					<textarea
						v-if="showNotes"
						v-model="notas"
						class="height-24 w-full rounded-lg border bg-background mt-2 p-2"
						placeholder="Escribe aquí tus notas..."
					>
					</textarea>
				</div>
			</div>

			<div
				v-if="cartItems.length > 0"
				class="flex flex-col justify-between pb-2"
			>
				<div class="space-y-2">
					<div
						v-for="cartItem in cartItems"
						:key="cartItem.id"
						class="border rounded-lg mb-0 overflow-hidden p-2 flex flex-col"
					>
						<div class="flex flex-row items-top space-x-4">
							<div class="h-20 w-20 flex-none rounded-lg bg-white overflow-hidden">
								<ProductPhotoComponent
									class=""
									:photo="cartItem.product.image"
								/>
							</div>
							<div class="w-full flex flex-col justify-between min-w-0">
								<div class="min-w-0">
									<div class="text-vc-body font-medium truncate">
										{{ cartItem.product.title.split(' - ')[0] }}
									</div>
									<div class="text-sm text-gray-600 truncate">
										{{ cartItem.product.title.split(' - ')[1] }}
									</div>
								</div>
								<div class="flex justify-between items-center mt-1 text-vc-body">
									<div>${{ formatPrice(cartItem.product.price) }}</div>
									<div class="flex items-center space-x-2">
										<QuantitySelector
											:quantity="cartItem.quantity"
											:maxQuantity="cartItem.product.variant?.quantityAvailable"
											@decrease="modifyCartItem(-1, cartItem.product)"
											@increase="modifyCartItem(1, cartItem.product)"
										/>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div
				v-else
				class="px-8 py-4 border border-black flex items-center justify-center text-center rounded-lg"
			>
				Explore nuestra selección de vinos o nuestras membresías
			</div>
		</div>
	</div>
</template>

<script>
import { onMounted, ref, computed, onUnmounted } from 'vue'
import { useCartStore } from '../stores/cart'
import axios from 'axios'
import ProductPhotoComponent from '@/components/ProductPhotoComponent.vue'
import { useToast } from 'vue-toast-notification'
import '../assets/toast.css'
import { useLoading } from 'vue-loading-overlay'
import QuantitySelector from '@/components/QuantitySelector.vue'
import { trackInitiateCheckout } from '@/services/facebookAnalytics'

export default {
	name: 'CartComponent',
	components: {
		ProductPhotoComponent,
		QuantitySelector
	},
	props: {
		toggle: {
			type: Function,
			required: true
		}
	},
	setup(props) {
		const store = useCartStore()
		const cartItems = ref([])
		const notas = ref('')
		const showNotes = ref(false)
		const showMerch = ref(false)
		const cartContainer = ref(null)

		const handleClickOutside = (event) => {
			if (cartContainer.value && !cartContainer.value.contains(event.target)) {
				props.toggle()
			}
		}

		onMounted(() => {
			cartItems.value = store.items
			document.addEventListener('mousedown', handleClickOutside)
		})

		onUnmounted(() => {
			document.removeEventListener('mousedown', handleClickOutside)
		})

		const $loading = useLoading({
			loader: 'spinner'
		})

		function formatPrice(price) {
			return Math.round(parseFloat(price)).toString()
		}

		function modifyCartItem(quantity, product) {
			let item = getCartItem(product)

			if (!item) {
				useToast().success('Producto agregado', { position: 'top' })
			} else if (item.quantity == 1 && quantity == -1) {
				useToast().success('Producto eliminado', { position: 'top' })
			} else {
				useToast().success('Cantidad acutalizada', { position: 'top' })
			}

			store.modifyCartItem(quantity, product)
		}

		function getCartItem(product) {
			return store.getCartItem(product)
		}

		function getCartItems() {
			return store.getCartItems()
		}

		const subTotal = computed(() => {
			return store.cartItemsTotal
		})

		const accessories = computed(() => {
			return store.availableMerch
		})

		const hasAvailableMerch = computed(() => {
			return accessories.value.some((accessory) => !getCartItem(accessory))
		})

		async function checkout() {
			if (store.items.length === 0) {
				return alert('¡Tu carrito está vacio!')
			}

			try {
				const cartItems = store.items.map((item) => ({
					id: item.product.id,
					quantity: item.quantity,
					price: parseFloat(item.product.price)
				}))
				trackInitiateCheckout({
					contents: cartItems,
					content_type: 'product',
					value: store.cartItemsTotal,
					currency: 'MXN'
				})
			} catch (error) {
				console.error('Error tracking checkout initiation:', error)
			}

			const loader = $loading.show({
				color: '#0F264D'
			})

			try {
				const { data } = await axios.post('/api/shopify/cart', {
					items: store.items,
					notes: notas.value
				})

				if (data.checkoutUrl) {
					// Save the cart ID
					store.setShopifyCartId(data.cartId)
					// Close the cart
					props.toggle()
					// Redirect to Shopify checkout
					window.location.href = data.checkoutUrl
				} else {
					alert('Hubo un error al crear el carrito. Por favor intenta de nuevo.')
				}
			} catch (error) {
				if (
					error.response?.status === 422 &&
					error.response?.data?.code === 'QUANTITY_VALIDATION_ERROR'
				) {
					// Validate and update cart quantities
					await store.validateAndUpdateCartQuantities()
					useToast().success(
						'Algunos productos han sido actualizados debido a cambios en el inventario',
						{ position: 'top' }
					)
					// Try checkout again with updated quantities
					checkout()
					return
				}

				console.error('Error creating cart:', error)
				alert('Hubo un error al crear el carrito. Por favor intenta de nuevo.')
			} finally {
				loader.hide()
			}
		}

		return {
			props,
			cartItems,
			accessories,
			modifyCartItem,
			getCartItem,
			getCartItems,
			subTotal,
			checkout,
			notas,
			showNotes,
			showMerch,
			formatPrice,
			cartContainer,
			hasAvailableMerch
		}
	}
}
</script>
